export default "__VITE_ASSET__D$y_S3o9__"